module.exports = __webpack_public_path__ + "img/title-center.10cf2444.png";